import store from '../index'
import config from '@/config'
import * as auth from '@/api/auth'

window.refreshTimeout = false
function validaRefresh () {
  // Refresh Token
  const dadosAuth = store.state.auth
  window.refreshTimeout = false

  if (dadosAuth.logado) {
    const dExpira = new Date(dadosAuth.token.expira)
    window.refreshTimeout = setTimeout(function () {
      if (window.inativoA >= config.tempoSessao) {
        store.dispatch('auth/logout')
      } else {
        store.dispatch('auth/refresh')
      }
    }, dExpira.getTime() - new Date().getTime() - (1000))
  }
}

function cleanRefresh () {
  if (window.refreshTimeout) clearTimeout(window.refreshTimeout)
}

function setAuth (dados) {
  dados.logado = true
  localStorage.setItem('auth', JSON.stringify(dados))
}

function getAuth () {
  // console.log('store modules auth getauth getauth')
  // console.log(JSON.parse(localStorage.getItem('auth')))
  return JSON.parse(localStorage.getItem('auth')) || false
}

function cleanAuth () {
  localStorage.removeItem('auth')
  localStorage.removeItem('comissoes')
}

function cleanAssinatura () {
  localStorage.removeItem('assinatura')
  localStorage.removeItem('assinaturaMsg')
}

function setAssinaturaMsg (dado) {
  localStorage.setItem('assinaturaMsg', JSON.stringify(dado))
}

function getAssinaturaMsg () {
  return JSON.parse(localStorage.getItem('assinaturaMsg')) !== false
}

function setAssinaturaDados (dado) {
  localStorage.setItem('assinatura', JSON.stringify(dado))
}

function getAssinaturaDados (dado) {
  if (dado) {
    return JSON.parse(localStorage.getItem('assinatura')) || false
  }
}

function getMessageBot () {
  return JSON.parse(sessionStorage.getItem('messageBot')) || false
}

const state = {
  logado: false,
  token: {},
  usuario: {},
  modalComunicado: false,
  assinatura: getAssinaturaDados(this.logado),
  assinaturaMsg: getAssinaturaMsg(),
  botMessage: getMessageBot()
}

const getters = {
  grupoComp: state => {
    if (!state.logado) return false
    let retorno = false
    switch (state.usuario.permissao.identificacao) {
      case 'promotor_loja':
        retorno = 'promotorLoja'
        console.log(retorno)
        // console.log('retorno ^')
        break
    }
    return 'promotorLoja'
  },
  root: state => {
    return state.usuario.grupo.id === 1
  },
  localizador: state => {
    return state.usuario.empresa_id === 18
  }
}

const mutations = {
  SETAUTH (state, dados) {
    setAuth(dados)
    state.logado = true
    state.token = dados.token
    state.usuario = dados.usuario
    validaRefresh()
  },
  REMOVEAUTH (state) {
    cleanAuth()
    cleanAssinatura()
    state.logado = false
    state.token = {}
    state.usuario = {}
    cleanRefresh()
  },
  SETMODALCOMUNICADO (state, payload) {
    state.modalComunicado = payload
  },
  SETVENCIDO (state, payload) {
    state.assinatura = payload
    setAssinaturaDados(payload)
  },
  SETASSINATURAMSG (state, payload) {
    state.assinaturaMsg = payload
    setAssinaturaMsg(payload)
  },
  CORRIGEAUTHSENHACOMISSIONAMENTO (state) {
    state.usuario.temSenhaComissao = true
    let dados = { token: state.token, usuario: state.usuario }
    setAuth(dados)
  },
  ALTERAPROMOTORA (state, payload) {
    state.usuario.empresa = payload
  },
  CLOSEMESSAGEBOT (state, payload) {
    state.botMessage = true
  }
}

const actions = {
  async setAuth ({ commit, dispatch }, payload) {
    commit('SETAUTH', payload.instancia)
    // await dispatch('history/clean', {}, { root: true })
    return dispatch('acesso/setPermissoes', payload.instancia.usuario.permissao, { root: true })
  },
  async removeAuth ({ commit, dispatch }) {
    let parceiro = store.state.auth.usuario.parceiro_id
    let parceiroObj = store.state.auth.usuario.parceiro
    commit('REMOVEAUTH')
    await dispatch('acesso/setPermissoes', null, { root: true })
    if (!parceiro) location.reload()
    else {
      var url = window.location.hostname
      if (url.includes('plataforma')) window.location.href = '/#/auth/logout'
      else window.location.href = '/#/auth/login/' + parceiroObj.nome
    }
  },
  async validaLogado ({ state, dispatch }) {
    if (state.logado) return state
    const auth = getAuth()
    if (!auth || auth.logado === false) throw new Error('Acesso Não Permitido!')
    const dExpira = new Date(auth.token.expira)
    if (dExpira.getTime() < new Date().getTime()) throw new Error('Acesso Não Permitido!')
    await dispatch('setAuth', { instancia: auth })
    return auth
  },
  async logar ({ dispatch, commit }, payload) {
    let retorno = await auth.logar(payload)
    await dispatch('setAuth', retorno)
    commit('SETMODALCOMUNICADO', true)
    if (retorno.instancia.usuario.permissao.length === 1) commit('SETVENCIDO', retorno.instancia.assinatura)
    return retorno
  },
  async logarToken ({ dispatch, commit }, payload) {
    let retorno = await auth.logarToken(payload)
    await dispatch('setAuth', retorno)
    commit('SETMODALCOMUNICADO', true)
    commit('SETVENCIDO', retorno.instancia.assinatura)
    return retorno
  },
  async refresh ({ state, dispatch }) {
    try {
      window.execRefresh = true
      await dispatch('setAuth', await auth.refresh(state.token.refresh))
      window.execRefresh = false
    } catch (e) {
      window.execRefresh = false
      return dispatch('logout')
    }
  },
  async logout ({ state, dispatch }) {
    try {
      await auth.logout(state.token.token)
      await dispatch('removeAuth')
    } catch (e) {
      await dispatch('removeAuth')
    }
  },
  async getGrupoComp ({ getters }) {
    return getters.grupoComp
  },
  fecharModalComunicado ({ commit }) {
    commit('SETMODALCOMUNICADO', false)
  },
  async recuperaSenha ({ state }, payload) {
    try {
      return auth.recuperaSenha(payload)
    } catch (e) {
      return e
    }
  },
  fecharMsgAssinatura ({ commit }) {
    commit('SETASSINATURAMSG', false)
  },
  mostrarMsgAssinatura ({ commit }) {
    commit('SETASSINATURAMSG', true)
  },
  corrigeAuthSenhaComissionamento ({ commit }) {
    commit('CORRIGEAUTHSENHACOMISSIONAMENTO')
  },
  alteraPromotora ({ commit }, payload) {
    payload.nome = payload.label
    payload.id = payload.value
    commit('ALTERAPROMOTORA', payload)
  },
  closeMessageBot ({ commit }) {
    sessionStorage.setItem('messageBot', true)
    commit('CLOSEMESSAGEBOT', true)
  }
}

export default { namespaced: true, state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/auth.js